import React from 'react';
import styled, { css } from 'styled-components';

import {
  paragraphSmallSize,
  paragraphSmallLineHeight,
} from '../../constants/text';

export const paragraphSmallStyle = css`
  font-size: ${paragraphSmallSize};
  line-height: ${paragraphSmallLineHeight};
  font-weight: 400;
`;

export const StyledParagraphSmall = styled.p`
  ${paragraphSmallStyle}
`;

export const ParagraphSmall = (props) => {
  const { children } = props;

  return <StyledParagraphSmall {...props}>{children}</StyledParagraphSmall>;
};
